const overdueIdPrefix = 'overdue--';

export const formatOverdueId = (id: string) => `${overdueIdPrefix}${id}`;

export const parseOverdueId = (id: string) => id.replace(overdueIdPrefix, '');
